import api from "./api";

export type AvaliacaoSituacaoLegacy = {
  id: number;
  nome: string;
};

export type AvaliacaoSolicitacaoLegacyItem = {
  cnpj: string;
  sigla: string;
  solicitacao: string;
  situacao: AvaliacaoSituacaoLegacy | null;
  enviadoPeloSindicatoEm: string | null;
  atualizadoPeloSindicatoEm: string | null;
  adequacaoSolicitadaEm: string | null;
  adequacaoRealizadaEm: string | null;
  analiseConcluidaEm: string | null;
  idQuestionarioResposta: number;
};

export type AvaliacaoSituacaoV2 = {
  id: number;
  nome: string;
};

export type AvaliacaoSolicitacaoV2Item = {
  cnpj: string;
  sigla: string;
  solicitacaoId: number;
  solicitacao: string;
  statusSolicitacaoAvaliacao: AvaliacaoSituacaoV2 | null;
  enviadoPeloSindicatoEm: string | null;
  atualizadoPeloSindicatoEm: string | null;
  adequacaoSolicitadaEm: string | null;
  adequacaoRealizadaEm: string | null;
  analiseConcluidaEm: string | null;
};

export type AvaliacaoModeloItem = {
  anoReferencia: number;
  criadoEm: string;
  ativo: boolean;
};

export type AvaliacaoSolicitacoesLegacyResponse = {
  anoReferenciaSelecionado: number;
  avaliacoesModelo?: AvaliacaoModeloItem[];
  solicitacoes: AvaliacaoSolicitacaoLegacyItem[];
};

export type AvaliacaoSolicitacoesResponse = {
  anoReferenciaSelecionado: number;
  novaSolicitacao?: boolean;
  avaliacoesModelo: AvaliacaoModeloItem[];
  solicitacoes: AvaliacaoSolicitacaoV2Item[];
};

export type SolicitacaoDetalheStatus = {
  id: number;
  nome: string;
};


export const STATUS_ANALISE_CRITERIO = {
  Pendente: 1,
  Conforme: 2,
  NaoConforme: 3,
  Devolver: 4,
} as const;

export type DadosSindicatoDetalhe = {
  id?: number;
  cnpj?: string;
  nome?: string;
  nomeSindicato?: string;
  sigla?: string;
  regional?: string;
  ordenacao?: number | string;
  grupo?: string;
  nomePresidente?: string;
  presidente?: string;
  emailSindicato?: string;
  telefoneSindicato?: string;
  nomeCoordenador?: string;
  telefoneCoordenador?: string;
  nomeCordenador?: string;
  telefoneCordenador?: string;
  responsavelPreenchimento?: string;
  cargoResponsavel?: string;
};

export type RespostaArquivo = {
  id: number;
  arquivoStorageId: number;
  nome: string;
  
  ativo?: boolean;
};

export type RespostaOpcaoCampo = {
  id: number;
  descricao: string;
  ordem: number;
};

export type CampoResposta = {
  id: number;
  valorTexto: string | null;
  valorInteiro: number | null;
  valorDecimal: number | null;
  valorBooleano: boolean | null;
  opcaoCampoId: number | null;
  opcoesSelecionadas: number[];
  opcoesSelecionadasIds?: number[] | null;
  arquivos: RespostaArquivo[];
};


export type TipoCampo = {
  id: number;
  nome: string;
};


export type CampoDetalhe = {
  id: number;
  titulo: string;
  tipo: TipoCampo;
  obrigatorio: boolean;
  ordem: number;
  podeEditar?: boolean;
  resposta: CampoResposta | null;
  opcoes: RespostaOpcaoCampo[];
};

export type PerguntaDetalhe = {
  id: number;
  titulo: string;
  obrigatorio: boolean;
  ordem: number;
  campos: CampoDetalhe[];
};

export type CriterioDetalhe = {
  id: number;
  criterioId: number;
  titulo: string;
  bonus: number;
  statusId: number;
  perguntas: PerguntaDetalhe[];
};

export type GrupoDetalhe = {
  id: number;
  titulo: string;
  ordem: number;
  prazoLimite: string;
  criterios: CriterioDetalhe[];
};

export type SolicitacaoDetalhe = {
  id: number;
  cnpj: string;
  sigla: string;
  status: SolicitacaoDetalheStatus;
  grupos: GrupoDetalhe[];
  dados?: DadosSindicatoDetalhe;
  enviadoPeloSindicatoEm?: string | null;
  
  adequacaoSolicitadaEm?: string | null;
  
  adequacaoRealizadaEm?: string | null;
  
  criteriosLiberadosParaAdequacaoIds?: number[] | null;
};


export type ReceitaOperacionalAnaliseItem = {
  valor: number;
  anoReferencia: number;
};

export type AssociadoAnaliseItem = {
  quantidade: number;
  anoReferencia: number;
};

export type AnalisePorCriterio = {
  id: number;
  observacaoSindicato?: string | null;
  observacaoAnalista?: string | null;
  observacaoInterna?: string | null;
  solicitadoEm?: string | null;
  adequadoEm?: string | null;
  status?: SolicitacaoDetalheStatus | null;
};

export type CriterioAnaliseView = {
  id: number;
  criterioId: number;
  titulo: string;
  
  status?: SolicitacaoDetalheStatus | null;
  statusId?: number;
  ordem: number;
  bonus?: number;
  perguntas: PerguntaDetalhe[];
  
  analise?: AnalisePorCriterio | AnalisePorCriterio[] | null;
};

export type GrupoAnaliseView = {
  id: number;
  titulo: string;
  ordem: number;
  
  prazoLimite: string | null;
  criterios: CriterioAnaliseView[];
};


export type SolicitacaoAnalise = {
  id: number;

  salarioMinimo?: number | null;
  receitasOperacionais: ReceitaOperacionalAnaliseItem[];
  associados: AssociadoAnaliseItem[];
  dados: DadosSindicatoDetalhe;

  status: SolicitacaoDetalheStatus | null;
  grupos: GrupoAnaliseView[];

  salarioMinimoAnoAnterior?: number | null;
  liberarSolicitacao?: boolean | null;
};

const parseObjectResponse = <T>(payload: unknown): T | null => {
  if (payload && typeof payload === "object") {
    return payload as T;
  }

  if (typeof payload === "string") {
    try {
      return JSON.parse(payload) as T;
    } catch (error) {
      console.error("❌ Erro ao fazer parse da resposta:", error);
      return null;
    }
  }

  return null;
};

const parseArrayResponse = <T>(payload: unknown): T[] => {
  if (Array.isArray(payload)) {
    return payload as T[];
  }

  if (typeof payload === "string") {
    try {
      const parsed = JSON.parse(payload);
      return Array.isArray(parsed) ? (parsed as T[]) : [];
    } catch (error) {
      console.error("❌ Erro ao fazer parse da resposta:", error);
      return [];
    }
  }

  return [];
};

// Busca as solicitações da versão legada da avaliação (2025)
// Endpoint: GET /api/avaliacoes/solicitacoes/legacy
export const getAvaliacaoSolicitacoesLegacy = async (): Promise<
  AvaliacaoSolicitacoesLegacyResponse | null
> => {
  try {
    const response = await api.get("/api/avaliacoes/solicitacoes/legacy");
    const parsed = parseObjectResponse<AvaliacaoSolicitacoesLegacyResponse>(
      response?.data,
    );
    if (parsed?.solicitacoes) {
      return parsed;
    }

    const legacyArray = parseArrayResponse<AvaliacaoSolicitacaoLegacyItem>(
      response?.data,
    );
    if (legacyArray.length > 0) {
      return {
        anoReferenciaSelecionado: 2025,
        avaliacoesModelo: [],
        solicitacoes: legacyArray,
      };
    }

    return parsed;
  } catch (error) {
    console.error("❌ Erro ao buscar solicitações legacy:", error);
    throw error;
  }
};

// Busca as solicitações da avaliação por ano de referência (2026+)
// Endpoint: GET /api/avaliacoes/solicitacoes?anoReferencia=ANO
export const getAvaliacaoSolicitacoesByAno = async (
  anoReferencia?: number | null,
): Promise<AvaliacaoSolicitacoesResponse | null> => {
  try {
    const params =
      anoReferencia === null || anoReferencia === undefined
        ? undefined
        : { anoReferencia };

    const response = await api.get("/api/avaliacoes/solicitacoes", { params });
    return parseObjectResponse<AvaliacaoSolicitacoesResponse>(response?.data);
  } catch (error) {
    console.error("❌ Erro ao buscar solicitações por ano:", error);
    throw error;
  }
};

// Cria uma nova solicitação de avaliação
// Endpoint: POST /api/avaliacoes/solicitacoes
export const criarAvaliacaoSolicitacao =
  async (): Promise<AvaliacaoSolicitacaoV2Item | null> => {
    try {
      const response = await api.post("/api/avaliacoes/solicitacoes");
      return parseObjectResponse<AvaliacaoSolicitacaoV2Item>(response?.data);
    } catch (error) {
      console.error("❌ Erro ao criar solicitação de avaliação:", error);
      throw error;
    }
  };

// Busca o detalhe completo de uma solicitação de avaliação
// Endpoint: GET /api/avaliacoes/solicitacoes/{idSolicitacao}

const validateStatusDetalheAnalise = (status: number) =>
  status === 200 ||
  status === 403 ||
  status === 404 ||
  (status >= 500 && status < 600);

export const getSolicitacaoDetalhe = async (
  idSolicitacao: number,
): Promise<SolicitacaoDetalhe | null> => {
  try {
    const response = await api.get(
      `/api/avaliacoes/solicitacoes/${idSolicitacao}`,
      {
        headers: { Accept: "application/json" },
        validateStatus: validateStatusDetalheAnalise,
      },
    );
    if (
      response.status === 404 ||
      response.status === 401 ||
      response.status === 403
    ) {
      // 404: só `/analise` existe; 401/403: perfil ou token — tentar outro endpoint no caller.
      return null;
    }
    if (response.status >= 500) {
      console.error(
        `❌ Erro ao buscar detalhe da solicitação (HTTP ${response.status}).`,
      );
      return null;
    }
    return parseObjectResponse<SolicitacaoDetalhe>(response?.data);
  } catch (error) {
    const status = (error as { response?: { status?: number } })?.response
      ?.status;
    if (status === 404 || status === 401 || status === 403) {
      return null;
    }
    if (status !== undefined && status >= 500) {
      console.error("❌ Erro ao buscar detalhe da solicitação:", error);
      return null;
    }
    console.error("❌ Erro ao buscar detalhe da solicitação:", error);
    return null;
  }
};

// Busca o payload completo da tela de análise (grupos, critérios, campos e bloco analise por critério)
// Endpoint: GET /api/avaliacoes/solicitacoes/{idSolicitacao}/analise
export const getSolicitacaoAnalise = async (
  idSolicitacao: number,
): Promise<SolicitacaoAnalise | null> => {
  try {
    const response = await api.get(
      `/api/avaliacoes/solicitacoes/${idSolicitacao}/analise`,
      {
        headers: { Accept: "application/json" },
        validateStatus: validateStatusDetalheAnalise,
      },
    );
    if (
      response.status === 404 ||
      response.status === 401 ||
      response.status === 403
    ) {
      // Sindicato costuma receber 403 em `/analise` (recurso do analista) — sem log; caller usa GET detalhe.
      return null;
    }
    if (response.status >= 500) {
      console.error(
        `❌ Erro ao buscar análise da solicitação (HTTP ${response.status}).`,
      );
      return null;
    }
    return parseObjectResponse<SolicitacaoAnalise>(response?.data);
  } catch (error) {
    const status = (error as { response?: { status?: number } })?.response
      ?.status;
    if (status === 404 || status === 401 || status === 403) {
      return null;
    }
    if (status !== undefined && status >= 500) {
      console.error("❌ Erro ao buscar análise da solicitação:", error);
      return null;
    }
    console.error("❌ Erro ao buscar análise da solicitação:", error);
    return null;
  }
};


export type PersistAnaliseSolicitacaoPayload = {
  apto: boolean;
  quantidadeAssociados: number;
  criterios: Array<{
    criterioId: number;
    statusId: number;
    observacaoAnalista?: string | null;
    observacaoInterna?: string | null;
  }>;
};


export type PatchAnaliseSolicitacaoBody = {
  receitaOperacional: number;
  associados: number;
  analiseCriterioSolicitacao: Array<{
    id: number;
    criterioId: number;
    observacaoAnalista?: string | null;
    observacaoInterna?: string | null;
    statusId: number;
  }>;
};

// PATCH /api/avaliacoes/solicitacoes/{idSolicitacao}/analise
export const patchSolicitacaoAnalise = async (
  idSolicitacao: number,
  payload: PatchAnaliseSolicitacaoBody,
): Promise<unknown> => {
  // eslint-disable-next-line no-console
  console.log(
    `[patchSolicitacaoAnalise] PATCH /api/avaliacoes/solicitacoes/${idSolicitacao}/analise payload:`,
    JSON.parse(JSON.stringify(payload)),
  );
  const response = await api.patch(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}/analise`,
    payload,
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
};


export const postSolicitacaoConcluirAnalise = async (
  idSolicitacao: number,
): Promise<void> => {
  await api.post(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}/conclusao-analise`,
    null,
    { headers: { "Content-Type": "application/json" } },
  );
};


export const postSolicitacaoSolicitarAdequacao = async (
  idSolicitacao: number,
): Promise<void> => {
  await api.post(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}/solicitacao-adequacao`,
    null,
    { headers: { "Content-Type": "application/json" } },
  );
};


export const postSolicitacaoAdequacao = async (
  idSolicitacao: number,
  PdfResumo: File | Blob,
): Promise<void> => {
  const formData = new FormData();
  formData.append("PdfResumo", PdfResumo, "PdfResumo.pdf");
  await api.post(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}/adequacao`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
};

export type CriterioLiberacao = {
  id: number;
  titulo: string;
};

export type GrupoCriterioLiberacao = {
  titulo: string;
  criteriosAvaliacao: CriterioLiberacao[];
};

export type AnaliseCriteriosLiberacaoResponse = {
  gruposCriterios: GrupoCriterioLiberacao[];
};

export const getAnaliseCriteriosLiberacao = async (
  idSolicitacao: number,
): Promise<AnaliseCriteriosLiberacaoResponse> => {
  const response = await api.get(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}/analise-criterios-liberacao`,
  );
  return response.data as AnaliseCriteriosLiberacaoResponse;
};

export const postLiberarNovaSolicitacao = async (
  idSolicitacao: number,
  avaliacaoCriteriosIds: number[],
): Promise<void> => {
  await api.post(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}/liberar-nova-solicitacao`,
    { avaliacaoCriteriosIds },
    { headers: { "Content-Type": "application/json" } },
  );
};

// PUT /api/avaliacoes/solicitacoes/{idSolicitacao}/analise/salvar
export const putAnaliseSolicitacaoSalvar = async (
  idSolicitacao: number,
  payload: PersistAnaliseSolicitacaoPayload,
): Promise<unknown> => {
  const response = await api.put(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}/analise/salvar`,
    payload,
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
};

// PUT /api/avaliacoes/solicitacoes/{idSolicitacao}/analise/finalizar
export const putAnaliseSolicitacaoFinalizar = async (
  idSolicitacao: number,
  payload: PersistAnaliseSolicitacaoPayload,
): Promise<unknown> => {
  const response = await api.put(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}/analise/finalizar`,
    payload,
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
};


export const putAnaliseSolicitacaoSolicitarAdequacao = async (
  idSolicitacao: number,
  payload: PersistAnaliseSolicitacaoPayload,
): Promise<unknown> => {
  const response = await api.put(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}/analise/solicitar-adequacao`,
    payload,
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
};

export type RequestRespostaCampoJson = {
  campoId: number;
  valorTexto?: string | null;
  valorInteiro?: number | null;
  valorDecimal?: number | null;
  opcaoCampoId?: number | null;
  opcoesSelecionadasIds?: number[] | null;
  arquivosIds?: number[] | null;
};

export type PatchAvaliacaoSolicitacaoPayload = {
  avaliacao?: {
    responsavelPreenchimento?: string;
    cargoResponsavel?: string;
  };
  sindicato?: {
    idSindicato?: number | string;
    telefoneSindicato?: string;
    nomeCoordenador?: string;
    telefoneCoordenador?: string;
    nomeCordenador?: string;
    telefoneCordenador?: string;
  };
  campos?: RequestRespostaCampoJson[];
  analiseCriterioSolicitacao?: Array<{
    id: number;
    criterioId: number;
    observacaoSindicato?: string | null;
  }>;
};

// Atualiza os dados da solicitação de avaliação
// Endpoint: PATCH /api/avaliacoes/solicitacoes/{idSolicitacao}
export const patchAvaliacaoSolicitacao = async (
  idSolicitacao: number,
  payload: PatchAvaliacaoSolicitacaoPayload,
): Promise<unknown> => {
  const response = await api.patch(
    `/api/avaliacoes/solicitacoes/${idSolicitacao}`,
    payload,
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
};

export type ArquivoRespostaCampo = {
  id: number;
  arquivoStorageId?: number;
  nome?: string;
  ativo?: boolean;
};

export function extrairArquivoRespostaCampoId(
  payload: unknown,
  depth = 0,
): number | null {
  if (depth > 6) return null;
  if (payload == null) return null;

  const asNum = (v: unknown): number | null => {
    if (typeof v === "number" && Number.isFinite(v) && v > 0) return v;
    if (typeof v === "string" && /^\d+$/.test(v)) {
      const n = parseInt(v, 10);
      return Number.isFinite(n) && n > 0 ? n : null;
    }
    return null;
  };

  const nDirect = asNum(payload);
  if (nDirect != null) return nDirect;

  if (typeof payload !== "object") return null;
  const o = payload as Record<string, unknown>;

  const fromKeys =
    asNum(o.id) ??
    asNum(o.arquivoRespostaCampoId) ??
    asNum(o.ArquivoRespostaCampoId);
  if (fromKeys != null) return fromKeys;

  const inner = o.data ?? o.result ?? o.payload ?? o.value;
  if (inner != null && inner !== payload) {
    return extrairArquivoRespostaCampoId(inner, depth + 1);
  }

  return null;
}

// Faz upload de arquivo vinculado a um campo da solicitação
// Endpoint: POST /api/avaliacoes/solicitacoes/{solicitacaoId}/campos/{campoId}/arquivo-resposta-campo
export const uploadArquivoRespostaCampo = async ({
  solicitacaoId,
  campoId,
  file,
}: {
  solicitacaoId: number;
  campoId: number;
  file: File;
}): Promise<ArquivoRespostaCampo> => {
  const formData = new FormData();
  formData.append("file", file, file.name);

  const response = await api.post(
    `/api/avaliacoes/solicitacoes/${solicitacaoId}/campos/${campoId}/arquivo-resposta-campo`,
    formData,
  );

  return response?.data as ArquivoRespostaCampo;
};

// Remove um arquivo vinculado a um campo da solicitação
// Endpoint: DELETE /api/avaliacoes/solicitacoes/arquivo-resposta-campo/{arquivoRespostaCampoId}
export const deleteArquivoRespostaCampo = async (
  arquivoRespostaCampoId: number,
): Promise<void> => {
  await api.delete(
    `/api/avaliacoes/solicitacoes/arquivo-resposta-campo/${arquivoRespostaCampoId}`,
  );
};

function getFilenameFromContentDispositionArq(cd = ""): string | null {
  if (!cd) return null;
  const fnStarMatch = cd.match(/filename\*\s*=\s*([^']*)''([^;]+)/i);
  if (fnStarMatch) {
    try {
      return decodeURIComponent(fnStarMatch[2]);
    } catch {
      return fnStarMatch[2];
    }
  }
  const fnMatch = cd.match(/filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i);
  if (fnMatch) {
    return (fnMatch[1] || fnMatch[2] || "").trim().replace(/^"(.*)"$/, "$1");
  }
  return null;
}

function isRenderableInBrowserArq(contentType = ""): boolean {
  const t = contentType.toLowerCase();
  return (
    t.startsWith("application/pdf") ||
    t.startsWith("image/") ||
    t.startsWith("text/") ||
    t.startsWith("application/json")
  );
}

function guessExtensionFromContentTypeArq(ct = ""): string {
  const map: Record<string, string> = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.ms-excel": "xls",
    "application/pdf": "pdf",
    "application/zip": "zip",
    "application/json": "json",
    "text/plain": "txt",
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/jpg": "jpg",
    "image/webp": "webp",
  };
  const norm = ct.toLowerCase().split(";")[0].trim();
  return map[norm] || "";
}

function ensureFilenameWithExtArq(
  baseName = "arquivo",
  contentType = "",
): string {
  if (/\.[a-z0-9]+$/i.test(baseName)) return baseName;
  const ext = guessExtensionFromContentTypeArq(contentType);
  return ext ? `${baseName}.${ext}` : baseName;
}

// Faz download ou abre no navegador um arquivo da solicitação
// Endpoint: GET /api/avaliacoes/solicitacoes/arquivo-resposta-campo/{arquivoRespostaCampoId}
export const downloadArquivoRespostaCampo = async (
  arquivoRespostaCampoId: number,
  nomeArquivoComExtensao = "arquivo",
): Promise<void> => {
  try {
    const response = await api.get(
      `/api/avaliacoes/solicitacoes/arquivo-resposta-campo/${arquivoRespostaCampoId}`,
      { responseType: "blob" },
    );

    const contentType = response.headers?.["content-type"] || "";
    const cd = response.headers?.["content-disposition"] || "";

    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const filenameFromHeader = getFilenameFromContentDispositionArq(cd);
    const filename = ensureFilenameWithExtArq(
      filenameFromHeader || nomeArquivoComExtensao,
      contentType,
    );

    if (isRenderableInBrowserArq(contentType)) {
      const win = window.open("", "_blank");
      if (win) {
        win.location.href = url;
      } else {
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
      setTimeout(() => URL.revokeObjectURL(url), 4000);
    } else {
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 0);
    }
  } catch {}
};

// Faz download do PDF da solicitação enviada
// Endpoint: GET /api/avaliacoes/solicitacoes/arquivo-solicitacao/{solicitacaoId}
export const downloadArquivoSolicitacaoPdf = async (
  solicitacaoId: number,
): Promise<void> => {
  try {
    const response = await api.get(
      `/api/avaliacoes/solicitacoes/arquivo-solicitacao/${solicitacaoId}`,
      { responseType: "blob" },
    );

    const contentType = response.headers?.["content-type"] || "application/pdf";
    const cd = response.headers?.["content-disposition"] || "";
    const filenameFromHeader = getFilenameFromContentDispositionArq(cd);
    const filename = ensureFilenameWithExtArq(
      filenameFromHeader || `solicitacao_${solicitacaoId}`,
      contentType || "application/pdf",
    );

    const blob = new Blob([response.data], { type: contentType || "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 0);
  } catch (error) {
    throw error;
  }
};

export type EnviarSolicitacaoPayload = {
  solicitacaoId: number;
  PdfResumo: File | Blob;
};

// Envia a solicitação de avaliação com o PDF resumo
// Endpoint: POST /api/avaliacoes/solicitacoes/enviar
export const enviarSolicitacao = async ({
  solicitacaoId,
  PdfResumo,
}: EnviarSolicitacaoPayload): Promise<unknown> => {
  const formData = new FormData();
  formData.append("PdfResumo", PdfResumo, "PdfResumo.pdf");

  try {
    const response = await api.post(
      `/api/avaliacoes/solicitacoes/${solicitacaoId}/envio`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
  } catch (error: any) {
    const status = error?.response?.status;
    const podeFallback = status === 404 || status === 405 || status === 400;
    if (!podeFallback) throw error;

    // Compatibilidade com ambientes que ainda expõem o endpoint antigo.
    const formDataLegacy = new FormData();
    formDataLegacy.append("solicitacaoId", String(solicitacaoId));
    formDataLegacy.append("PdfResumo", PdfResumo, "PdfResumo.pdf");
    const legacyResponse = await api.post(
      "/api/avaliacoes/solicitacoes/enviar",
      formDataLegacy,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return legacyResponse.data;
  }
};

// Busca os eventos históricos de uma solicitação da avaliação V2
// Endpoint: GET /api/avaliacoes/solicitacoes/{solicitacaoId}/eventos
export const getEventosSolicitacaoAvaliacao = async (solicitacaoId: number) => {
  const response = await api.get(
    `/api/avaliacoes/solicitacoes/${solicitacaoId}/eventos`,
  );
  return response.data;
};
